// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3Qo09","name":"ConsentHeader_name__heBQH","birthday":"ConsentHeader_birthday__3eetO","skeleton":"ConsentHeader_skeleton__1NB_E"};